var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eg-slideshow"},_vm._l((_vm.images[_vm.preference]),function(imageUrl,i){return _c('eg-image-slide',{key:i,attrs:{"enter":(i === 0) ? null : 'slideInRight',"leave":"slideOutLeft","url":imageUrl}})}))}
var staticRenderFns = []

export { render, staticRenderFns }